import { initAllCarousels } from './carousel';

type InitAllCarouselsProps = {
  disablePreview: boolean;
};

/**
 * TODO: Remove disablePreview here. The Storybook logic shouldn't get in here.
 * See example here: /ts/src/rolex/rolex-slider.ts
 */
// eslint-disable-next-line import/prefer-default-export
export function initAllCmsCarousels({ disablePreview }: InitAllCarouselsProps = { disablePreview: false }): void {
  if (disablePreview) {
    return;
  }

  const CMS_CAROUSEL = 'cms-carousel';
  initAllCarousels(CMS_CAROUSEL);
}
